export default function ServerError() {
  return (
    <div className="text-center h-[100vh] flex align-center flex-col justify-center">
      <h1>500 – Server Error</h1>
      <p>Something went wrong on our side. Please try again later.</p>
    </div>
  );
}
